export default class AdwordsGoogleLocalStores {
  constructor(context) {
    this.context = context;
    this.axios = this.context.$axios;
  }
  // LOCAL STORES
  async getGoogleSearch(
    subscriberId,
    businessUnitId,
    fromDate,
    toDate,
    customerId
  ) {
    try {
      const googleSearch = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL_GOOGLE}/adwords/local-stores/PERFORMANCE_MAX/${customerId}/businesses/${businessUnitId}/LCH?fromDate=${fromDate}&toDate=${toDate}`
      );

      return {
        ...googleSearch.data
      };
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }

  // PAGES
  async getGoogleSearchPages(subscriberId, businessUnitId, fromDate, toDate) {
    try {
      const googleSearch = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/google-analytics/summary-pages/business/${businessUnitId}/${subscriberId}?toDate=${toDate}&fromDate=${fromDate}`
      );

      return {
        ...googleSearch.data
      };
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }
}
